// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addActiveCode-container .grop-tip[data-v-69ffe305] {\n  color: #ccc;\n}\n", ""]);
// Exports
module.exports = exports;
